
import 'three/examples/js/lines/LineSegments2';
import 'three/examples/js/lines/LineSegmentsGeometry';

import SbpLineVertexShader from '../../shaders/sbp/sbp.vert';
import SbpBinLineFragmentShader from '../../shaders/sbp/sbp_bin_line.frag';

import { Palettes, LineTypes } from './SBPVisualizer';

export default class SBPBinLine extends THREE.LineSegments2 {
  constructor (geometry, lw = 6.35, rw = 1820, rh = 910) {
    let uniforms = THREE.UniformsUtils.merge([
      THREE.UniformsLib.common,
      {
        t: { value: 1.0 },
        mColor: { value: Palettes[LineTypes.MOVE].color },
        jColor: { value: Palettes[LineTypes.JOG].color },
        pColor: { value: Palettes[LineTypes.POCKET].color },
        linewidth: { value: lw },
        resolution: { value: new THREE.Vector2(rw, rh) }
      }
    ]);

    // https://threejs.org/docs/?q=Depth#api/en/constants/Materials
    const material = new THREE.ShaderMaterial({
      vertexShader: SbpLineVertexShader,
      fragmentShader: SbpBinLineFragmentShader,
      transparent: false,
      // depthTest: false,
      // depthWrite: false,
      depthFunc: THREE.GreaterEqualDepth,
      vertexColors: THREE.VertexColors,
      uniforms: uniforms
    });
    material.uniforms.diffuse.value = new THREE.Color(0xffffff);

    super(geometry, material);
  }

  setResolution (w, h) {
    this.material.uniforms.resolution.value.x = w;
    this.material.uniforms.resolution.value.y = h;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/sbp/SBPBinLine.js